<div class="page-wrapper manage-event">
  <HomeNavBar />
  <InactivityModal />
  <div v-if="is_loading" class="text-center py-5 w-100">
  <div class="spinner-border text-secondary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <p class="mt-2 mb-0 text-muted">Loading</p>
</div>
  <div v-else>
    <!-- Top nav bar -->
    <div class="card rounded px-4 py-3">
      <div class="row align-items-center gy-2">
        <!-- LEFT -->
        <div class="col-12 col-md-4 d-flex align-items-center gap-3">
          <span
            class="btn rounded-circle p-2 d-flex align-items-center justify-content-center membership-view-back-btn"
            @click="back"
          >
            <i class="bi bi-arrow-left fs-4"></i>
            
          </span>

          <span
            class="badge rounded d-inline-flex align-items-center gap-1 small fw-medium"
            :class="event?.is_published
                    ? 'bg-success-subtle text-success border border-success'
                    : 'bg-warning-subtle text-warning border border-warning'"
          >
            <i
              :class="event?.is_published ? 'bi bi-check-circle-fill' : 'bi bi-pencil-fill'"
            ></i>
            {{ event?.is_published ? 'Published' : 'Draft' }}
          </span>
        </div>

        <!-- CENTER (title) -->
        <div class="col-12 col-md-4 text-md-center text-start overflow-hidden">
          <div class="fw-bold portal-truncate">{{ event?.event_name }}</div>
        </div>

        <!-- RIGHT -->
        <div
          class="col-12 col-md-4 d-flex justify-content-md-end gap-2 flex-wrap flex-md-nowrap"
        >
          <button
            class="btn btn-sm btn-primary rounded text-xxs cursor-pointer nav-item.position-relative"
            @click="go_to_event"
          >
            View Event
          </button>
        </div>
      </div>
    </div>

    <!-- Main layout -->
    <div class="my-1 me-lg-2 scrollable-container">
      <input
        type="file"
        ref="fileInput"
        class="d-none"
        accept="image/*"
        @change="on_file_change"
      />
      <div class="row">
        <div class="col-12 manage-event-tabs-row mb-1">
          <div class="portal-tabs-card portal-tabs-strip bg-banner-gradient manage-event-tabs rounded mb-2 mx-auto">
            <div class="tabs-wrapper d-flex align-items-center px-2 py-1">
              <div class="scrollable-tabs flex-grow-1">
                <ul
                  class="nav nav-tabs nav-justified w-100 border-0 text-xxs px-2 gap-0 portal-icon-tabs"
                  role="tablist"
                  aria-label="Manage event tabs"
                >
                  <li class="nav-item" role="presentation">
                    <button
                      type="button"
                      class="nav-link portal-icon-tab d-inline-flex justify-content-center align-items-center"
                      :class="{ active: active_manage_tab === 'basic' }"
                      :aria-selected="active_manage_tab === 'basic'"
                      role="tab"
                      @click="set_manage_tab('basic')"
                    >
                      <i class="bi bi-info-circle-fill"></i>
                      <span>Basic info</span>
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      type="button"
                      class="nav-link portal-icon-tab d-inline-flex justify-content-center align-items-center"
                      :class="{ active: active_manage_tab === 'advanced' }"
                      :aria-selected="active_manage_tab === 'advanced'"
                      role="tab"
                      @click="set_manage_tab('advanced')"
                    >
                      <i class="bi bi-sliders"></i>
                      <span>Advanced</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Publish checklist (Moves to Right on Desktop, stays Top on Mobile) -->
        <div
          v-if="active_manage_tab === 'basic'"
          class="col-lg-4 order-lg-2 d-none d-lg-flex flex-column gap-1"
        >
           <!-- Cover image upload Card -->
          <div
            class="card rounded overflow-hidden mb-2"
            role="button"
            @click="trigger_upload"
          >
            <div
              v-if="!cover_image_preview"
              class="card-body d-flex flex-column align-items-center justify-content-center banner-cover"
            >
              <div class="upload-icon-circle">
                <i class="bi bi-image text-muted fs-4"></i>
              </div>
              <p class="mb-0 text-primary fw-medium text-xxxs">
                Upload cover image
              </p>
            </div>

            <div v-else class="position-relative banner-cover">
              <div class="ratio ratio-4x3">
                <img
                  :src="cover_image_preview"
                  class="marketplace-card-image event-image-container"
                  alt="Cover Preview"
                />
              </div>
              <div class="position-absolute top-0 end-0 m-2">
                <button
                  class="btn btn-sm btn-primary border shadow-sm text-xxxs fw-medium px-3 py-2"
                  @click.stop="trigger_upload"
                >
                  <i class="bi bi-arrow-repeat me-1"></i> Change image
                </button>
              </div>
            </div>
          </div>

          <!-- Publish checklist (Desktop) -->
          <div :class="['card rounded', is_free ? 'my-1' : 'mt-1 mb-5']">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <p class="text-xxs fw-500 mb-0">Publish checklist</p>
                <span class="text-muted text-xxxs">{{ checked_count }}/{{ check_list.length }}</span>
              </div>
              <div class="progress mb-3 progress">
                <div
                  class="progress-bar bg-banner-gradient"
                  role="progressbar"
                  :style="{ width: progress_width }"
                  aria-valuenow="25"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              <div class="d-flex flex-column gap-2 mb-3">
                <div
                  v-for="item in check_list"
                  :key="item.label"
                  class="d-flex align-items-center gap-2 text-xxs"
                  :class="item.done ? 'text-body' : 'text-muted'"
                >
                  <i v-if="item.done" class="bi bi-check-circle-fill text-success"></i>
                  <i v-else class="bi bi-circle text-secondary"></i>
                  {{ item.label }}
                </div>
              </div>
              <!-- Smart Publish Area -->
              <div class="d-flex flex-column gap-3">
                <!-- Info Alert (Show if not published and has issues) -->
                <div
                  v-if="(!is_checklist_complete || !date_validation_passed)"
                  class="alert alert-secondary d-flex align-items-start gap-2 text-xxs mb-0 py-2"
                  role="alert"
                >
                  <i class="bi bi-info-circle-fill mt-1 flex-shrink-0"></i>
                  <div class="d-flex flex-column gap-1 text-start">
                    <span v-if="!is_checklist_complete" class="fw-600">Complete the checklist above to publish.</span>
                    <div v-if="!date_validation_passed">
                      <span class="fw-600">Resolve validation errors to publish:</span>
                      <ul class="mb-0 ps-3">
                        <div v-for="(msg, key) in errors" :key="key">
                          <li v-if="msg">{{ msg }}</li>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex flex-column gap-2">
                  <!-- Save Changes Button (shown if dirty) -->
                  <div v-if="has_unsaved_changes" class="text-xxs text-muted text-center py-2">
                    <span v-if="is_autosaving">
                      <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                      Saving changes...
                    </span>
                    <span v-else-if="autosave_error" class="text-danger">{{ autosave_error }}</span>
                    <span v-else>Changes will save automatically.</span>
                  </div>
                  <!-- Publish/Unpublish Button -->
                  <div v-if="!has_unsaved_changes">
                    <button
                      v-if="!event?.is_published && (!is_checklist_complete || !date_validation_passed)"
                      class="btn btn-sm btn-secondary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2 opacity-50 cursor-not-allowed"
                      disabled
                    >
                      <i class="bi bi-send-fill me-1"></i>
                      Publish Event
                    </button>
                    <button
                      v-else
                      class="btn btn-sm btn-primary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2"
                      @click="publish_event"
                    >
                      <i :class="event.is_published ? 'bi bi-send-slash-fill' : 'bi bi-send-fill'" class="me-1"></i>
                      {{ event.is_published ? 'Unpublish' : 'Publish Event' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Main Content (Moves to Left on Desktop, stays Bottom on Mobile) -->
        <div
          class="d-flex flex-column mb-5 mb-xl-0"
          :class="active_manage_tab === 'basic' ? 'col-lg-8 order-lg-1' : 'col-12'"
        >
          <!-- Cover image upload (Mobile) -->
          <div
            v-if="active_manage_tab === 'basic'"
            class="card rounded overflow-hidden mb-2 d-lg-none"
            role="button"
            @click="trigger_upload"
          >
            <div
              v-if="!cover_image_preview"
              class="card-body d-flex flex-column align-items-center justify-content-center banner-cover"
            >
              <div class="upload-icon-circle">
                <i class="bi bi-image text-muted fs-4"></i>
              </div>
              <p class="mb-0 text-primary fw-medium text-xxxs">
                Upload cover image
              </p>
            </div>

            <div v-else class="position-relative banner-cover">
              <div class="ratio ratio-4x3">
                <img
                  :src="cover_image_preview"
                  class="marketplace-card-image event-image-container"
                  alt="Cover Preview"
                />
              </div>
              <div class="position-absolute top-0 end-0 m-2">
                <button
                  class="btn btn-sm btn-primary border shadow-sm text-xxxs fw-medium px-3 py-2"
                  @click.stop="trigger_upload"
                >
                  <i class="bi bi-arrow-repeat me-1"></i> Change image
                </button>
              </div>
            </div>
          </div>

          <div v-if="active_manage_tab === 'basic'">
          <!-- Event details card -->
          <div class="card rounded">
            <div class="card-body">
              <!--Event Category-->
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Event Category</label>
                <div class="d-flex flex-row align-items-center gap-3">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="free_event"
                      name="event_category"
                      :value="true"
                      v-model="is_free"
                      checked
                    />
                    <label class="form-check-label text-xxs" for="free_event">Free</label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="paid_event"
                      name="event_category"
                      :value="false"
                      v-model="is_free"
                    />
                    <label class="form-check-label text-xxs" for="paid_event">Paid</label>
                  </div>
                </div>
              </div>
              <!--Organizer-->
              <div class="mb-3">
                <label for="organizer" class="form-label text-xxs fw-500">Organizer</label>
                <input
                  type="text"
                  class="form-control rounded text-xxs"
                  id="organizer"
                  placeholder="Enter organizer name"
                  v-model="organizer"
                />
                <p v-if="errors.organizer" class="text-danger text-xxs">
                  {{ errors.organizer }}
                </p>
              </div>
              <div class="mb-3" v-if="portals.length">
                <label for="portal_id" class="form-label text-xxs fw-500">Portal</label>
                <select
                  id="portal_id"
                  class="form-select rounded text-xxs"
                  v-model="portal_id"
                >
                  <option value="">Select portal</option>
                  <option v-for="portal in portals" :key="portal.id" :value="portal.id">
                    {{ portal.name }}
                  </option>
                </select>
                <div class="alert alert-warning py-1 px-3 text-xs mt-1" role="alert">
                    Only members of the selected portal will see event.
                </div>
              </div>
              <div class="mb-3" v-if="is_free">
                <label class="form-label text-xxs fw-500">Event Capacity</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control rounded text-xxs"
                    v-model.number="event_capacity"
                    min="0"
                    placeholder="e.g., 100"
                  />
                </div>
                <p v-if="errors.event_capacity" class="text-danger text-xxs">{{ errors.event_capacity }}</p>
            </div>
              <!--Description-->
              <div class="mb-3">
                <label class="form-label text-xxs fw-500">Event Description</label>
                <div>
                  <QuillEditor
                    theme="snow"
                    v-model:content="event_description"
                    contentType="html"
                    ref="quillEventEditorRef"
                    class="quill-editor"
                    placeholder="Enter your description here..."
                    toolbar="full"
                  />
                </div>
              </div>
              <!--Event Start and end date-->
              <div class="row">
                <!-- Event Start Date -->
                <div class="col-md-3 mb-3">
                  <label for="start_date" class="form-label text-xxs fw-500"
                    >Event Start Date
                  </label>
                  <input
                    type="date"
                    class="form-control rounded text-xxs"
                    id="start_date"
                    v-model="start_date"
                    :min="today_date"
                  />
                  <p v-if="errors.start_date" class="text-danger text-xxs">
                    {{ errors.start_date }}
                  </p>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="end_time" class="form-label text-xxs fw-500"
                    >Start Time
                  </label>
                  <input
                    type="time"
                    class="form-control rounded text-xxs"
                    id="start_time"
                    v-model="start_time"
                    :min="start_time_min_value()"
                  />

                  <p v-if="errors.start_time" class="text-danger text-xxs mt-1">
                    {{ errors.start_time }}
                  </p>
                </div>

                <!-- Event End Date -->
                <div class="col-md-3 mb-3">
                  <label for="end_date" class="form-label text-xxs fw-500"
                    >Event End Date
                  </label>
                  <input
                    type="date"
                    class="form-control rounded text-xxs"
                    id="end_date"
                    v-model="end_date"
                    :min="event_end_date_min_value()"
                  />
                  <p v-if="errors.end_date" class="text-danger text-xxs">
                    {{ errors.end_date }}
                  </p>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="end_time" class="form-label text-xxs fw-500"
                    >End Time
                  </label>
                  <input
                    type="time"
                    class="form-control rounded text-xxs"
                    id="end_time"
                    v-model="end_time"
                    :min="end_time_min_value()"
                  />
                  <p v-if="errors.end_time" class="text-danger text-xxs">
                    {{ errors.end_time }}
                  </p>
                </div>
                <!-- RSVP Start Date -->
                <div v-if="is_free" class="col-md-3 mb-3">
                  <label
                    for="rsvp_start_date"
                    class="form-label text-xxs fw-500"
                    >RSVP Start Date</label>
                  <input
                    type="date"
                    class="form-control rounded text-xxs"
                    id="rsvp_start_date"
                    v-model="rsvp_start_date"
                    :max="rsvp_start_date_max_value()"
                  />
                  <p v-if="errors.rsvp_start_date" class="text-danger text-xxs">
                    {{ errors.rsvp_start_date }}
                  </p>
                </div>
                <div v-if="is_free" class="col-md-3 mb-3">
                  <label
                    for="rsvp_start_time"
                    class="form-label text-xxs fw-500"
                    >RSVP Start Time</label>
                  <input
                    type="time"
                    class="form-control rounded text-xxs"
                    id="rsvp_start_time"
                    v-model="rsvp_start_time"
                    :min="rsvp_start_time_min_value()"
                    :max="rsvp_start_time_max_value()"
                  />
                  <p v-if="errors.rsvp_start_time" class="text-danger text-xxs">
                    {{ errors.rsvp_start_time }}
                  </p>
                </div>

                <!-- RSVP End Date -->
                <div v-if="is_free" class="col-md-3 mb-3">
                  <label for="rsvp_end_date" class="form-label text-xxs fw-500"
                    >RSVP End Date</label>
                  <input
                    type="date"
                    class="form-control rounded text-xxs"
                    id="rsvp_end_date"
                    v-model="rsvp_end_date"
                    :min="rsvp_end_date_min_value()"
                    :max="rsvp_end_date_max_value()"
                  />
                  <p v-if="errors.rsvp_end_date" class="text-danger text-xxs">
                    {{ errors.rsvp_end_date }}
                  </p>
                </div>
                <div v-if="is_free" class="col-md-3 mb-3">
                  <label for="rsvp_end_time" class="form-label text-xxs fw-500"
                    >RSVP End Time</label>
                  <input
                    type="time"
                    class="form-control rounded text-xxs"
                    id="rsvp_end_time"
                    v-model="rsvp_end_time"
                    :min="rsvp_end_time_min_value()"
                    :max="rsvp_end_time_max_value()"
                  />
                  <p v-if="errors.rsvp_end_time" class="text-danger text-xxs">
                    {{ errors.rsvp_end_time }}
                  </p>
                </div>

              </div>
            </div>
          </div>

          <!-- Ticket types card -->
          <div  v-if="!is_free"  class="card rounded my-2">
            <div class="card-body">
              <div class="d-flex flex-column align-items-start gap-3 mb-3">
                <div class="d-inline-flex align-items-center gap-2 bg-light border rounded-pill px-3 py-2 text-muted text-sm">
                  <i class="bi bi-calendar-event text-primary"></i>
                  <span class="fw-medium text-xxs">
                    {{ new_format_date(start_date + 'T' + start_time) }} - {{ new_format_date(end_date + 'T' + end_time) }}
                  </span>
                </div>
              </div>
              <!-- Header Row -->
              <div
                class="d-flex align-items-center justify-content-between mb-3"
              >
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-ticket text-secondary"></i>
                  <span class="text-xxs fw-500">Tickets</span>
                  <span
                    class="d-inline-flex align-items-center justify-content-center rounded-circle text-white fw-bold bg-banner-gradient text-xxxs w-20px h-20"
                  >
                    {{ tickets.length }}
                  </span>
                </div>
                <button
                  type="button"
                  @click="add_ticket"
                  class="d-flex align-items-center bg-primary border rounded px-3 py-2 fw-semibold text-xxs text-white cursor-pointer"
                >
                  Add ticket
                </button>
              </div>
              <!-- Ticket Cards — rendered only after clicking Add -->
              <div
                v-for="(ticket, index) in tickets"
                :key="ticket.id"
                class="border overflow-hidden rounded mb-3"
              >
                <!-- Card Header -->
                <div
                  class="d-flex align-items-center justify-content-between px-3 py-2"
                >
                  <span class="fw-bold text-xxs text-secondary">
                    Ticket {{ index + 1 }}
                  </span>
                  <button
                    v-if="!(event.is_published && ticket.ticket_id)"
                    type="button"
                    @click="remove_ticket(index)"
                    class="d-flex align-items-center justify-content-center border-0 rounded"
                  >
                    <i class="bi bi-x text-danger text-xxs"></i>
                  </button>
                </div>

                <!-- Card Body -->
                <div class="p-3">
                  <!-- Ticket Name -->
                  <div class="mb-3 position-relative">
                    <input
                      type="text"
                      class="form-control rounded text-xxs"
                      v-model="ticket.name"
                      placeholder="Type or select a ticket type"
                      @focus="active_ticket_dropdown_index = index"
                      @input="active_ticket_dropdown_index = index"
                      @blur="active_ticket_dropdown_index === index && (active_ticket_dropdown_index = null)"
                      autocomplete="off"
                      :disabled="event.is_published && ticket.ticket_id"
                    />
                    <ul
                      class="dropdown-menu w-100 max-h-200"
                      :class="{ show: active_ticket_dropdown_index === index && get_filtered_tickets(ticket.name).length }"
                      v-if="active_ticket_dropdown_index === index"
                    >
                      <li
                        v-for="t in get_filtered_tickets(ticket.name)"
                        :key="t.id"
                      >
                        <button
                          class="dropdown-item text-xxs"
                          type="button"
                          @mousedown.prevent="ticket.name = t.name; active_ticket_dropdown_index = null"
                        >
                          {{ t.name }}
                        </button>
                      </li>
                    </ul>
                    <p v-if="errors[`ticket_${index}_name`]" class="text-danger text-xxs mt-1 mb-0">
                      {{ errors[`ticket_${index}_name`] }}
                    </p>
                  </div>

                  <!-- Price & Quantity -->
                  <div class="row g-2">
                    <div class="col-6">
                      <label class="form-label text-xxs fw-500">Price (R)</label>
                      <input
                        type="number"
                        class="form-control rounded text-xxs"
                        v-model.number="ticket.price"
                        step="0.01"
                        min="0"
                        placeholder="0.00"
                        :disabled="event.is_published && ticket.ticket_id"
                      />
                      <p v-if="errors[`ticket_${index}_price`]" class="text-danger text-xxs mt-1 mb-0">
                        {{ errors[`ticket_${index}_price`] }}
                      </p>
                    </div>
                    <div class="col-6">
                      <label class="form-label text-xxs fw-500">Quantity</label>
                      <input
                        type="number"
                        class="form-control rounded text-xxs pac-target-input"
                        v-model.number="ticket.quantity"
                        min="0"
                        placeholder="e.g. 100"
                        :disabled="event.is_published && ticket.ticket_id"
                      />
                      <p v-if="errors[`ticket_${index}_quantity`]" class="text-danger text-xxs mt-1 mb-0">
                        {{ errors[`ticket_${index}_quantity`] }}
                      </p>
                    </div>
                  </div>

                  <!-- Start Date -->
                  <div class="row g-2 mb-2">
                    <div class="mb-2 col-md-6">
                      <label class="form-label text-xxs fw-500">Ticket Sale Start Date <span class="text-danger">*</span></label>
                      <input
                        type="datetime-local"
                        class="form-control rounded text-xxs"
                        v-model="ticket.start_date"
                        :max="ticket_sale_max_datetime()"
                      />
                      <p
                        v-if="errors[`ticket_${index}_start_date`]"
                        class="text-danger text-xxs mt-1 mb-0"
                      >
                        {{ errors[`ticket_${index}_start_date`] }}
                      </p>
                    </div>

                    <!-- End Date -->
                    <div class="col-md-6">
                      <label class="form-label text-xxs fw-500">Ticket Sale End Date <span class="text-danger">*</span></label>
                      <input
                        type="datetime-local"
                        class="form-control rounded text-xxs"
                        v-model="ticket.end_date"
                        :min="ticket_sale_end_min_datetime(ticket)"
                        :max="ticket_sale_max_datetime()"
                      />
                      <p
                        v-if="errors[`ticket_${index}_end_date`]"
                        class="text-danger text-xxs mt-1 mb-0"
                      >
                        {{ errors[`ticket_${index}_end_date`] }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Publish checklist (Mobile) -->
          <div class="d-lg-none">
            <div :class="['card rounded', is_free ? 'my-1' : 'mt-1 mb-5']">
              <div class="card-body">
                <div class="d-flex justify-content-between mb-2">
                  <p class="text-xxs fw-500 mb-0">Publish checklist</p>
                  <span class="text-muted text-xxxs">{{ checked_count }}/{{ check_list.length }}</span>
                </div>
                <div class="progress mb-3 progress">
                  <div
                    class="progress-bar bg-banner-gradient"
                    role="progressbar"
                    :style="{ width: progress_width }"
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <div class="d-flex flex-column gap-2 mb-3">
                  <div
                    v-for="item in check_list"
                    :key="item.label"
                    class="d-flex align-items-center gap-2 text-xxs"
                    :class="item.done ? 'text-body' : 'text-muted'"
                  >
                    <i v-if="item.done" class="bi bi-check-circle-fill text-success"></i>
                    <i v-else class="bi bi-circle text-secondary"></i>
                    {{ item.label }}
                  </div>
                </div>
                <!-- Smart Publish Area -->
                <div class="d-flex flex-column gap-3">
                  <!-- Info Alert (Show if not published and has issues) -->
                  <div
                    v-if="(!is_checklist_complete || !date_validation_passed)"
                    class="alert alert-secondary d-flex align-items-start gap-2 text-xxs mb-0 py-2"
                    role="alert"
                  >
                    <i class="bi bi-info-circle-fill mt-1 flex-shrink-0"></i>
                    <div class="d-flex flex-column gap-1 text-start">
                      <span v-if="!is_checklist_complete" class="fw-600">Complete the checklist above to publish.</span>
                      <div v-if="!date_validation_passed">
                        <span class="fw-600">Resolve validation errors to publish:</span>
                        <ul class="mb-0 ps-3">
                          <div v-for="(msg, key) in errors" :key="key">
                            <li v-if="msg">{{ msg }}</li>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Action Buttons -->
                  <div class="d-flex flex-column gap-2">
                    <!-- Save Changes Button (shown if dirty) -->
                  <div v-if="has_unsaved_changes" class="text-xxs text-muted text-center py-2">
                    <span v-if="is_autosaving">
                      <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                      Saving changes...
                    </span>
                    <span v-else-if="autosave_error" class="text-danger">{{ autosave_error }}</span>
                    <span v-else>Changes will save automatically.</span>
                  </div>
                    <!-- Publish/Unpublish Button -->
                    <div v-if="!has_unsaved_changes">
                      <button
                        v-if="!event?.is_published && (!is_checklist_complete || !date_validation_passed)"
                        class="btn btn-sm btn-secondary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2 opacity-50 cursor-not-allowed"
                        disabled
                      >
                        <i class="bi bi-send-fill me-1"></i>
                        Publish Event
                      </button>
                      <button
                        v-else
                        class="btn btn-sm btn-primary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2"
                        @click="publish_event"
                      >
                        <i :class="event.is_published ? 'bi bi-send-slash-fill' : 'bi bi-send-fill'" class="me-1"></i>
                        {{ event.is_published ? 'Unpublish' : 'Publish Event' }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="is_free" class="card rounded my-2">
            <div class="card-body" v-if="show_add_extras">
              <!-- Header Row (match Tickets) -->
              <div
                class="d-flex align-items-center justify-content-between mb-3"
              >
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-tags text-secondary"></i>
                  <span class="text-xxs fw-500">Event Offerings</span>
                  <span
                    class="d-inline-flex align-items-center justify-content-center rounded-circle text-white fw-bold bg-banner-gradient text-xxxs w-20px h-20"
                  >
                    {{ extra_forms.length }}
                  </span>
                </div>
                <button
                  type="button"
                  @click.prevent="add_extra"
                  class="d-flex align-items-center bg-primary border rounded px-3 py-2 fw-semibold text-xxs text-white cursor-pointer"
                >
                  Add extra
                </button>
              </div>

              <!-- Extra Cards (match Ticket card layout) -->
              <div v-if="show_extras_form && extra_forms.length > 0">
                <div
                  v-for="(extraForm, extraIndex) in extra_forms"
                  :key="extraIndex"
                  class="border overflow-hidden rounded mb-3"
                >
                  <!-- Card Header -->
                  <div
                    class="d-flex align-items-center justify-content-between px-3 py-2"
                  >
                    <span class="fw-bold text-xxs text-secondary">
                      Extra {{ extraIndex + 1 }}
                    </span>
                    <button
                      type="button"
                      @click.prevent="remove_extra(extraIndex)"
                      class="d-flex align-items-center justify-content-center border-0 rounded"
                    >
                      <i class="bi bi-x text-danger text-xxs"></i>
                    </button>
                  </div>

                  <!-- Card Body -->
                  <div class="p-3">
                    <input
                      v-model="extraForm.id"
                      type="text"
                      class="d-none extra_form_id"
                    />

                    <div class="mb-3">
                      <label class="form-label text-xxs fw-500">Extra Type</label>
                      <input
                        type="text"
                        class="form-control rounded text-xxs"
                        v-model="extraForm.selectedExtra"
                        placeholder="e.g. Meal 1"
                        :list="'extrasList-' + extraIndex"
                      />
                      <datalist :id="'extrasList-' + extraIndex">
                        <option
                          v-for="extra in extras"
                          :key="extra.id"
                          :value="extra.name"
                        ></option>
                      </datalist>
                    </div>

                    <div class="mt-3">
                      <div
                        class="d-flex align-items-center justify-content-between mb-2"
                      >
                        <h6 class="text-xxs mb-0 text-secondary">Items</h6>
                        <button
                          @click.prevent="add_extra_item(extraIndex)"
                          class="d-flex align-items-center bg-primary border rounded px-3 py-2 fw-semibold text-xxs text-white cursor-pointer"
                          type="button"
                        >
                          Add item
                        </button>
                      </div>

                      <div
                        v-for="(item, itemIndex) in extraForm.items"
                        :key="itemIndex + '_extra'"
                        class="border rounded mb-2"
                      >
                        <div class="p-3">
                          <input
                            v-model="item.id"
                            type="text"
                            class="d-none item_id"
                          />

                          <div class="row g-2 align-items-start">
                            <div class="col-12 col-md-3">
                              <label class="form-label text-xxs fw-500">Name</label>
                              <input
                                v-model="item.item_name"
                                type="text"
                                class="form-control rounded text-xxs"
                                placeholder="e.g. Burger, Chips"
                              />
                            </div>

                            <div class="col-12 col-md-5">
                              <label class="form-label text-xxs fw-500">Description</label>
                              <textarea
                                v-model="item.item_description"
                                class="form-control rounded text-xxs"
                                rows="1"
                                placeholder="Enter description"
                              ></textarea>
                            </div>

                            <div class="col-12 col-md-3">
                              <label class="form-label text-xxs fw-500">Price</label>
                              <div class="input-group input-group-sm">
                                <span class="input-group-text text-xxs">R</span>
                                <input
                                  v-model="item.item_price"
                                  type="number"
                                  class="form-control rounded text-xxs"
                                  placeholder="0.00"
                                  step="0.01"
                                  min="0"
                                />
                              </div>
                            </div>

                            <div
                              class="col-12 col-md-1 d-flex justify-content-end align-items-end"
                            >
                              <button
                                @click.prevent="remove_extra_item(extraIndex, itemIndex)"
                                class="d-flex align-items-center justify-content-center border-0 rounded"
                                type="button"
                                title="Remove Item"
                              >
                                <i class="bi bi-x text-danger text-xxs"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>

          <div v-if="active_manage_tab === 'advanced'">
            <!-- Advanced layout -->
            <div class="row">
              <!-- Desktop side tabs -->
              <div class="col-lg-4 order-lg-2 d-none d-lg-flex flex-column gap-1">
                <div class="card rounded">
                  <div class="card-body">
                    <div class="list-group list-group-flush">
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'agenda' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent '"
                        @click="set_advanced_section('agenda')">
                        <i class="bi bi-clock"></i>
                        Agenda
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'venue_setup' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('venue_setup')">
                        <i class="bi bi-building-gear"></i>
                        Venue setup
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'speakers' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('speakers')">
                        <i class="bi bi-mic"></i>
                        Speakers
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'survey' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('survey')">
                        <i class="bi bi-card-checklist"></i>
                        Survey
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'photo_wall' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('photo_wall')">
                        <i class="bi bi-images"></i>
                        Event gallery
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'event_slides' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('event_slides')">
                        <i class="bi bi-easel"></i>
                        Event slides
                      </button>
                      <button
                        v-if="!is_free"
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'promo_codes' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('promo_codes')">
                        <i class="bi bi-tag"></i>
                        Promo codes
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'recurring' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('recurring')">
                        <i class="bi bi-arrow-repeat"></i>
                        Recurring
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'sponsors' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('sponsors')">
                        <i class="bi bi-award"></i>
                        Sponsors
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card rounded mt-1 mb-5">
                  <div class="card-body">
                    <div class="d-flex justify-content-between mb-2">
                      <p class="text-xxs fw-500 mb-0">Publish checklist</p>
                      <span class="text-muted text-xxxs">{{ checked_count }}/{{ check_list.length }}</span>
                    </div>
                    <div class="progress mb-3 progress">
                      <div
                        class="progress-bar bg-banner-gradient"
                        role="progressbar"
                        :style="{ width: progress_width }"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>

                    <div class="d-flex flex-column gap-2 mb-3">
                      <div
                        v-for="item in check_list"
                        :key="item.label"
                        class="d-flex align-items-center gap-2 text-xxs"
                        :class="item.done ? 'text-body' : 'text-muted'"
                      >
                        <i v-if="item.done" class="bi bi-check-circle-fill text-success"></i>
                        <i v-else class="bi bi-circle text-secondary"></i>
                        {{ item.label }}
                      </div>
                    </div>

                    <div class="d-flex flex-column gap-3">
                      <div
                        v-if="(!is_checklist_complete || !date_validation_passed)"
                        class="alert alert-secondary d-flex align-items-start gap-2 text-xxs mb-0 py-2"
                        role="alert"
                      >
                        <i class="bi bi-info-circle-fill mt-1 flex-shrink-0"></i>
                        <div class="d-flex flex-column gap-1 text-start">
                          <span v-if="!is_checklist_complete" class="fw-600">Complete the checklist above to publish.</span>
                          <div v-if="!date_validation_passed">
                            <span class="fw-600">Resolve validation errors to publish:</span>
                            <ul class="mb-0 ps-3">
                              <div v-for="(msg, key) in errors" :key="key">
                                <li v-if="msg">{{ msg }}</li>
                              </div>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex flex-column gap-2">
                  <div v-if="has_unsaved_changes" class="text-xxs text-muted text-center py-2">
                    <span v-if="is_autosaving">
                      <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                      Saving changes...
                    </span>
                    <span v-else-if="autosave_error" class="text-danger">{{ autosave_error }}</span>
                    <span v-else>Changes will save automatically.</span>
                  </div>
                        <div v-if="!has_unsaved_changes">
                          <button
                            v-if="!event?.is_published && (!is_checklist_complete || !date_validation_passed)"
                            class="btn btn-sm btn-secondary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2 opacity-50 cursor-not-allowed"
                            disabled
                          >
                            <i class="bi bi-send-fill me-1"></i>
                            Publish Event
                          </button>
                          <button
                            v-else
                            class="btn btn-sm btn-primary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2"
                            @click="publish_event"
                          >
                            <i :class="event.is_published ? 'bi bi-send-slash-fill' : 'bi bi-send-fill'" class="me-1"></i>
                            {{ event.is_published ? 'Unpublish' : 'Publish Event' }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Main content -->
              <div class="d-flex flex-column mb-5 mb-xl-0 col-lg-8 order-lg-1">
                <!-- Mobile advanced actions -->
                <div v-if="active_manage_tab === 'advanced'" class="d-flex d-lg-none align-items-center gap-2 px-2 mb-2">
                  <button
                    class="btn btn-sm px-3"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#manageEventAdvancedNav"
                    aria-controls="manageEventAdvancedNav"
                  >
                    <i class="bi bi-list me-1 fs-2"></i>
                  </button>
                </div>

                <div
                  :class="[
                    'card rounded',
                    active_manage_tab === 'advanced' && ['photo_wall', 'event_slides'].includes(active_advanced_section)
                      ? 'mb-2 mb-lg-5'
                      : 'mb-5'
                  ]"
                >
                  <div class="card-body">
                  <div v-if="active_advanced_section === 'speakers'">
                    <EventSpeaker
                      ref="eventSpeakerInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'survey'">
                    <EventSurvey
                      ref="eventSurveyInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                      @survey-updated="on_survey_updated"
                      @survey-deleted="on_survey_deleted"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'photo_wall'">
                    <EventMediaGallery
                      ref="eventMediaGalleryInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                      @media-updated="on_media_updated"
                      @media-deleted="on_media_deleted"
                      @visibility-updated="on_gallery_visibility_updated"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'event_slides'">
                    <EventResource
                      ref="eventResourceInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                      @documents-updated="on_documents_updated"
                      @document-deleted="on_document_deleted"
                      @visibility-updated="on_slides_visibility_updated"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'promo_codes' && !is_free">
                    <PromoCode
                      ref="promoManagerInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                      @promo-updated="on_promo_updated"
                      @promo-deleted="on_promo_deleted"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'venue_setup'">
                    <div class="border rounded overflow-hidden bg-white">
                      <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 border-bottom px-3 py-3">
                        <div>
                          <h6 class="fw-bold text-dark mb-1"><i class="bi bi-grid-3x3-gap-fill text-primary me-2"></i>Venue & seating builder</h6>
                          <p class="text-muted text-xxs mb-0">Build your floor plan and assign guests to seats.</p>
                        </div>
                        <div class="d-flex flex-wrap gap-2 text-xxs">
                          <span class="badge bg-light text-dark border rounded-pill px-3 py-2">Tables <b>{{ venue_tables.length }}</b></span>
                          <span class="badge bg-primary-subtle text-primary border rounded-pill px-3 py-2">Seated <b>{{ seated_venue_guests_count }}/{{ venue_seat_capacity }}</b></span>
                          <span class="badge bg-success-subtle text-success border rounded-pill px-3 py-2">Available <b>{{ venue_available_seats }}</b></span>
                        </div>
                      </div>

                      <div v-if="seating_error" class="alert alert-danger rounded-0 border-start-0 border-end-0 mb-0 py-2 text-xxs" role="alert">
                        <i class="bi bi-exclamation-circle me-2"></i>{{ seating_error }}
                      </div>

                      <div class="row g-0">
                        <aside class="col-12 col-lg-4 border-end">
                          <div class="p-3">
                            <div class="input-group input-group-sm mb-3">
                              <input id="venue_guest_search" v-model="venue_guest_search" type="search" class="form-control text-xxs rounded" placeholder="Search name, table or seat" />
                            </div>

                            <div v-if="venue_guest_search.trim()">
                              <div class="d-flex justify-content-between text-muted text-uppercase text-xxs mb-2"><span>Search results</span><span>{{ searched_venue_guests.length }}</span></div>
                              <p v-if="!searched_venue_guests.length" class="text-muted text-xxs py-3 text-center">No guests found.</p>
                              <button v-for="guest in searched_venue_guests" :key="guest.id" type="button" class="btn w-100 d-flex align-items-center justify-content-between gap-2 border rounded text-start mb-2 px-3 py-2 bg-light text-dark" @click="show_venue_guest_location(guest)">
                                <span class="d-flex align-items-center gap-2"><i class="bi bi-person-circle text-primary"></i><span class="fw-semibold text-xxs">{{ guest.name }}</span></span>
                                <span v-if="guest.table_id !== null" class="d-flex align-items-center gap-2 text-end text-xxs"><span><span class="d-block fw-semibold text-primary">{{ venue_table_name(guest.table_id) }}</span><span class="text-muted">Seat {{ guest.seat_number }}</span></span><i class="bi bi-x-circle text-danger" role="button" tabindex="0" title="Unassign guest" @click.stop="unassign_venue_guest(guest.id)" @keydown.enter.stop="unassign_venue_guest(guest.id)"></i></span>
                                <span v-else class="badge bg-light text-muted border rounded-pill">Unassigned</span>
                              </button>
                            </div>

                            <div v-else>
                              <div class="d-flex justify-content-between text-muted text-uppercase text-xxs mb-2">
                                <span>All guests</span><span>{{ venue_guests.length }}</span>
                              </div>
                              <p v-if="!venue_guests.length" class="text-muted text-xxs py-3 text-center">No guests have been added.</p>
                              <button
                                v-for="guest in venue_guests"
                                :key="guest.id"
                                type="button"
                                class="btn w-100 d-flex align-items-center justify-content-between gap-2 border rounded text-start mb-2 px-3 py-2 text-xxs"
                                :class="selected_venue_guest_id === guest.id ? 'btn-primary' : 'bg-light text-dark'"
                                :disabled="seating_submitting"
                                @click="selected_venue_guest_id === guest.id ? (selected_venue_guest_id = null) : show_venue_guest_location(guest)"
                              >
                                <span class="d-flex align-items-center gap-2"><i class="bi bi-person-circle"></i><span class="fw-semibold">{{ guest.name }}</span></span>
                                <span v-if="guest.table_id !== null" class="text-end text-xxs">
                                  <span class="d-block fw-semibold" :class="selected_venue_guest_id === guest.id ? 'text-white' : 'text-primary'">{{ venue_table_name(guest.table_id) }}</span>
                                  <span :class="selected_venue_guest_id === guest.id ? 'text-white' : 'text-muted'">Seat {{ guest.seat_number }}</span>
                                  <i class="bi bi-x-circle ms-1" :class="selected_venue_guest_id === guest.id ? 'text-white' : 'text-danger'" role="button" tabindex="0" title="Unassign guest" @click.stop="unassign_venue_guest(guest.id)" @keydown.enter.stop="unassign_venue_guest(guest.id)"></i>
                                </span>
                                <span v-else class="badge bg-white text-muted border rounded-pill">Unassigned</span>
                              </button>
                            </div>
                          </div>
                        </aside>

                        <section class="col-12 col-lg-8">
                          <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 border-bottom px-3 py-3">
                            <div class="d-flex flex-wrap align-items-center gap-2">
                              <button type="button" class="btn btn-sm bg-primary text-white rounded shadow" :disabled="seating_loading || seating_submitting" @click="add_venue_table">
                                <span v-if="seating_submitting" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                                Add table
                              </button>
                            </div>
                            <span class="text-muted text-xxs"><i class="bi bi-cursor me-1"></i>Select a guest, then choose a seat</span>
                          </div>

                          <div class="p-4 seating-grid">
                            <div v-if="seating_loading" class="h-100 d-flex flex-column align-items-center justify-content-center text-center py-5">
                              <span class="spinner-border text-primary mb-3" aria-hidden="true"></span>
                              <p class="text-muted text-xxs mb-0">Loading seating layout...</p>
                            </div>
                            <div v-else-if="!venue_tables.length" class="h-100 d-flex flex-column align-items-center justify-content-center text-center py-5">
                              <span class="d-inline-flex align-items-center justify-content-center bg-white border rounded-circle text-primary mb-3 seating-empty-icon"><i class="bi bi-table fs-4"></i></span>
                              <p class="fw-bold text-dark text-xxs mb-1">Start building your venue</p>
                              <p class="text-muted text-xxs mb-0">Add a table above, then choose how many seats it needs.</p>
                            </div>
                            <div v-else>
                              <div class="d-flex flex-wrap justify-content-center gap-3 border-bottom pb-4 mb-4">
                                <button
                                  v-for="table in venue_tables"
                                  :key="table.id"
                                  type="button"
                                  class="btn rounded-circle d-flex flex-column align-items-center justify-content-center p-1 shadow-sm text-white table-circle"
                                  :class="selected_venue_table_id === table.id ? 'btn-primary' : 'btn-warning'"
                                  :disabled="seating_submitting"
                                  @click="toggle_venue_table_preview(table)"
                                >
                                  <span class="fw-bold text-xxs">{{ table.name }}</span>
                                  <span class="table-circle-count">{{ table.seats }} {{ table.seats === 1 ? 'seat' : 'seats' }}</span>
                                </button>
                              </div>

                              <div v-if="selected_venue_table" class="bg-white border rounded shadow-sm p-3 p-md-4">
                                <div class="d-flex justify-content-end mb-2">
                                  <button type="button" class="btn btn-sm btn-light border rounded-circle d-inline-flex align-items-center justify-content-center p-0 table-preview-close" aria-label="Close table preview" title="Close preview" @click="selected_venue_table_id = null">
                                    <i class="bi bi-x-lg"></i>
                                  </button>
                                </div>
                                <div class="d-flex flex-wrap align-items-end justify-content-between gap-3 mb-4">
                                  <div>
                                    <div class="d-flex align-items-center gap-2 mb-2">
                                      <span class="fw-bold text-dark">{{ selected_venue_table.name }}</span>
                                      <span class="badge bg-light text-muted border rounded-pill">{{ selected_venue_table.seat_assignments.length }}/{{ selected_venue_table.seats }} seated</span>
                                    </div>
                                    <label class="form-label text-muted text-xxs mb-1">Number of seats</label>
                                    <div class="input-group input-group-sm seat-capacity-control">
                                      <input
                                        v-model="venue_table_seat_drafts[selected_venue_table.id]"
                                        type="number"
                                        min="0"
                                        step="1"
                                        class="form-control text-center text-xxs"
                                        :disabled="seating_submitting"
                                        @keydown.enter.prevent
                                      />
                                      <span class="input-group-text text-xxs">seats</span>
                                      <button type="button" class="btn btn-primary text-xxs px-3" :disabled="seating_submitting" @click="save_venue_table_seats">
                                        <span v-if="seating_submitting" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                                        <i v-else class="bi bi-check2 me-1"></i>Save
                                      </button>
                                    </div>
                                    <p v-if="Number(venue_table_seat_drafts[selected_venue_table.id]) < highest_assigned_venue_seat(selected_venue_table)" class="text-warning text-xxs mb-0 mt-1"><i class="bi bi-exclamation-triangle me-1"></i>Assigned seats may be affected. You will be asked to confirm.</p>
                                  </div>
                                </div>

                                <div class="position-relative mx-auto table-seat-layout">
                                  <div class="position-absolute top-50 start-50 translate-middle rounded-circle border border-3 bg-light d-flex flex-column align-items-center justify-content-center text-center table-preview-circle">
                                    <span class="fw-bold text-dark">{{ selected_venue_table.name }}</span>
                                    <span class="text-muted text-xxs mt-1">{{ selected_venue_table.seats }} seats</span>
                                  </div>
                                  <button
                                    v-for="seat in venue_seat_numbers(selected_venue_table)"
                                    :key="seat"
                                    type="button"
                                    class="btn position-absolute rounded-circle d-flex align-items-center justify-content-center p-0 text-xxs shadow-sm seat-circle"
                                    :class="venue_guest_for_seat(selected_venue_table.id, seat) ? 'btn-primary' : (selected_venue_guest_id ? 'btn-outline-primary bg-white' : 'btn-warning text-white')"
                                    :disabled="seating_submitting || (venue_guest_for_seat(selected_venue_table.id, seat) && selected_venue_guest_id && String(venue_guest_for_seat(selected_venue_table.id, seat).id) !== String(selected_venue_guest_id))"
                                    :style="venue_seat_style(seat, selected_venue_table.seats)"
                                    :title="venue_guest_for_seat(selected_venue_table.id, seat) ? venue_guest_for_seat(selected_venue_table.id, seat).name : `Seat ${seat}`"
                                    @click="assign_venue_seat(selected_venue_table.id, seat)"
                                  >
                                    <span v-if="venue_guest_for_seat(selected_venue_table.id, seat)" class="fw-bold">{{ venue_guest_for_seat(selected_venue_table.id, seat).name.split(' ').map(part => part[0]).join('').slice(0, 2) }}</span>
                                    <span v-else>{{ seat }}</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>

                  </div>

                  <div v-else-if="active_advanced_section === 'recurring'">
                    <div class="d-flex align-items-center gap-2 mb-3">
                      <i class="bi bi-arrow-repeat text-primary"></i>
                      <span class="fw-semibold text-xxs">Recurring Event</span>
                    </div>

                    <div class="mb-3">
                      <label class="form-label text-xxs fw-500">Is Recurring?</label>
                      <div class="d-flex flex-row align-items-center gap-3">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            id="advanced_recurring_yes"
                            :value="true"
                            v-model="is_recurring"
                          />
                          <label class="form-check-label text-xxs" for="advanced_recurring_yes">Yes</label>
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            id="advanced_recurring_no"
                            :value="false"
                            v-model="is_recurring"
                          />
                          <label class="form-check-label text-xxs" for="advanced_recurring_no">No</label>
                        </div>
                      </div>
                    </div>

                    <div class="mb-0" v-if="is_recurring">
                      <label for="advanced_recurring_type" class="form-label text-xxs fw-500">Recurrence Pattern <span class="text-danger">*</span></label>
                      <select
                        class="form-select rounded text-xxs"
                        id="advanced_recurring_type"
                        v-model="recurring_type"
                      >
                        <option value="">Select recurrence</option>
                        <option
                          v-for="pattern in recurring_patterns"
                          :key="pattern.id"
                          :value="pattern.id"
                        >
                          {{ pattern.name }}
                        </option>
                      </select>
                      <p v-if="errors.recurring_type" class="text-danger text-xxs">
                        {{ errors.recurring_type }}
                      </p>
                    </div>

                    <div v-if="has_unsaved_changes" class="text-xxs text-muted text-center mt-4">
                      <span v-if="is_autosaving">
                        <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                        Saving changes...
                      </span>
                      <span v-else-if="autosave_error" class="text-danger">{{ autosave_error }}</span>
                      <span v-else>Changes will save automatically.</span>
                    </div>
                  </div>

                  <div v-else-if="active_advanced_section === 'sponsors'">
                    <EventSponsor
                      ref="eventSponsorInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'agenda'">
                    <EventAgenda
                      ref="eventAgendaInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                      @agenda-updated="on_agenda_updated"
                    />
                  </div>

                  <div v-else>
                    <div class="d-flex align-items-center gap-2 fw-bold">
                      <i
                        :class="active_advanced_section === 'agenda' ? 'bi bi-clock text-primary'
                          : active_advanced_section === 'venue_setup' ? 'bi bi-building-gear text-primary'
                          : active_advanced_section === 'photo_wall' ? 'bi bi-images text-primary'
                          : active_advanced_section === 'event_slides' ? 'bi bi-easel text-primary'
                          : active_advanced_section === 'promo_codes' ? 'bi bi-tag text-primary'
                          : active_advanced_section === 'recurring' ? 'bi bi-arrow-repeat text-primary'
                          : 'bi bi-award text-primary'"></i>
                      <span class="text-capitalize">{{ active_advanced_section.replace('_', ' ') }}</span>
                    </div>

                    <div class="text-muted text-sm mt-2">
                      Manage {{ active_advanced_section.replace('_', ' ') }} for this event.
                    </div>

                    <div class="mt-3">
                      <button
                        type="button"
                        class="btn btn-sm btn-primary rounded-pill px-3"
                        @click="open_advanced_section"
                      >
                        Open
                      </button>
                    </div>
                  </div>
                  </div>
                </div>

                <div class="d-lg-none mb-3">
                  <div class="card rounded">
                    <div class="card-body">
                      <div class="d-flex justify-content-between mb-2">
                        <p class="text-xxs fw-500 mb-0">Publish checklist</p>
                        <span class="text-muted text-xxxs">{{ checked_count }}/{{ check_list.length }}</span>
                      </div>
                      <div class="progress mb-3 progress">
                        <div
                          class="progress-bar bg-banner-gradient"
                          role="progressbar"
                          :style="{ width: progress_width }"
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>

                      <div class="d-flex flex-column gap-2 mb-3">
                        <div
                          v-for="item in check_list"
                          :key="item.label"
                          class="d-flex align-items-center gap-2 text-xxs"
                          :class="item.done ? 'text-body' : 'text-muted'"
                        >
                          <i v-if="item.done" class="bi bi-check-circle-fill text-success"></i>
                          <i v-else class="bi bi-circle text-secondary"></i>
                          {{ item.label }}
                        </div>
                      </div>

                      <div class="d-flex flex-column gap-3">
                        <div
                          v-if="(!is_checklist_complete || !date_validation_passed)"
                          class="alert alert-secondary d-flex align-items-start gap-2 text-xxs mb-0 py-2"
                          role="alert"
                        >
                          <i class="bi bi-info-circle-fill mt-1 flex-shrink-0"></i>
                          <div class="d-flex flex-column gap-1 text-start">
                            <span v-if="!is_checklist_complete" class="fw-600">Complete the checklist above to publish.</span>
                            <div v-if="!date_validation_passed">
                              <span class="fw-600">Resolve validation errors to publish:</span>
                              <ul class="mb-0 ps-3">
                                <div v-for="(msg, key) in errors" :key="key">
                                  <li v-if="msg">{{ msg }}</li>
                                </div>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex flex-column gap-2">
                  <div v-if="has_unsaved_changes" class="text-xxs text-muted text-center py-2">
                    <span v-if="is_autosaving">
                      <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                      Saving changes...
                    </span>
                    <span v-else-if="autosave_error" class="text-danger">{{ autosave_error }}</span>
                    <span v-else>Changes will save automatically.</span>
                  </div>
                          <div v-if="!has_unsaved_changes">
                            <button
                              v-if="!event?.is_published && (!is_checklist_complete || !date_validation_passed)"
                              class="btn btn-sm btn-secondary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2 opacity-50 cursor-not-allowed"
                              disabled
                            >
                              <i class="bi bi-send-fill me-1"></i>
                              Publish Event
                            </button>
                            <button
                              v-else
                              class="btn btn-sm btn-primary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2"
                              @click="publish_event"
                            >
                              <i :class="event.is_published ? 'bi bi-send-slash-fill' : 'bi bi-send-fill'" class="me-1"></i>
                              {{ event.is_published ? 'Unpublish' : 'Publish Event' }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Mobile offcanvas side tabs -->
            <div
              class="offcanvas offcanvas-start"
              tabindex="-1"
              id="manageEventAdvancedNav"
              aria-labelledby="manageEventAdvancedNavLabel"
            >
              <div class="offcanvas-header mb-5"></div>
              <div class="offcanvas-body p-2">
                <div class="offcanvas-header d-flex justify-content-between align-items-center">
                  <h5 class="offcanvas-title" id="manageEventAdvancedNavLabel">Advanced</h5>
                  <div class="d-flex align-items-center gap-2">
                    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                  </div>
                </div>
                <div class="list-group list-group-flush">
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'agenda' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('agenda')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-clock"></i> Agenda
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'venue_setup' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('venue_setup')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-building-gear"></i> Venue setup
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'speakers' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('speakers')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-mic"></i> Speakers
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'survey' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('survey')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-card-checklist"></i> Survey
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'sponsors' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('sponsors')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-award"></i> Sponsors
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'photo_wall' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('photo_wall')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-images"></i> Event gallery
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'event_slides' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('event_slides')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-easel"></i> Event slides
                  </button>
                  <button
                    v-if="!is_free"
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'promo_codes' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('promo_codes')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-tag"></i> Promo codes
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'recurring' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('recurring')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-arrow-repeat"></i> Recurring
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Advanced components are rendered inline per section -->
</div>